import { Duration, formatDuration } from "date-fns";

export const formatExecutionDuration = (duration: Duration) =>
  formatDuration(duration, {
    delimiter: ", ",
    format: duration.years
      ? ["years", "months"]
      : duration.months
        ? ["months", "days"]
        : duration.days
          ? ["days", "hours"]
          : duration.hours
            ? ["hours", "minutes"]
            : duration.minutes
              ? ["minutes"]
              : ["seconds"],
  });

export function calculateReturnAmount(
  book: {
    price: bigint;
    total: bigint;
    value: bigint;
  }[],
  remaining: bigint
): bigint {
  if (book.length === 0 || remaining <= 0n) return 0n;
  const [next, ...rest] = book;
  const total = next.total;
  const value = next.value;
  if (!value) return total + calculateReturnAmount(rest, remaining);
  const returned = (total * remaining) / value;

  if (remaining >= value)
    return total + calculateReturnAmount(rest, remaining - value);
  return returned;
}
